// DO NOT EDIT THIS FILE BECAUSE IT IS GENERATED AUTOMATICALLY
"use client";

import React from "react";
import styled from "styled-components";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SVG = styled.svg.withConfig({
  componentId: "sc-lyboom-0"
})(["min-width:", ";max-width:", ";height:", ";"], ({
  $size
}) => $size, ({
  $size
}) => $size, ({
  $size
}) => $size);

/**
 * Indicates a dropdown menu or hidden options.
 *
 * @param {object} props - The component props
 * @param {string} [props.size] - The width/height of the icon as any CSS size unit
 * @param {string} [props.color] - The fill color of the icon as any CSS color value
 * @param {string} [props.title] - The title to add as a child of the root svg element
 *
 * @returns {React.ReactElement} - The ArrowDropDown component
 */
const ArrowDropDown = ({
  size = "1em",
  color = "currentColor",
  title,
  ...props
}) => /*#__PURE__*/_jsxs(SVG, {
  ...props,
  $size: size,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  role: title ? 'img' : 'presentation',
  children: [title ? /*#__PURE__*/_jsx("title", {
    children: title
  }) : null, " ", /*#__PURE__*/_jsx("path", {
    fill: color,
    d: "M7.24 9.69c-.404-.38-.286-.69.264-.69h8.993c.549 0 .666.31.264.69l-4.4 4.169a.527.527 0 0 1-.721 0L7.24 9.69Z",
    children: " "
  })]
});
export default ArrowDropDown;